/**
 * Utility function to determine if phone verification modal should be shown
 * @param userData - User data object from API
 * @returns boolean - true if modal should be shown, false otherwise
 */
export const shouldShowPhoneVerificationModal = (userData: any): boolean => {
  if (!userData) {
    console.log('Phone Verification Check: No userData')
    return false
  }

  const isPhone = userData?.phone
  const generateLimit = userData?.generation_limit
  const newPlans = ['discover', 'all access 99', 'all access 1', 'free']
  const newPlanUser = newPlans.includes(userData?.subscription_plan)


  // Check if user is on a new plan and hasn't verified phone yet and has no generate limit used
  if (newPlanUser && (isPhone === false || isPhone === null) && generateLimit < 1) {
    return true
  }

  return false
}

